import { css, useTheme } from '@emotion/react';
import * as React from 'react';

import { useCategoryState } from '../category/category-state';
import { MapPinPointSelected } from '../icons/map-pin-point-selected-icon';
import { MapPinPointUnselected } from '../icons/map-pin-point-unselected-icon';
import { IcaMapPin } from '../icons/map-pins/ica';

interface PinpointMarkerProps {
  name: string;
  selected: boolean;
}

export const PlainPinpointMarker: React.FC<PinpointMarkerProps> = ({ name, selected }) => {
  const theme = useTheme();

  const icon = selected ? (
    <MapPinPointSelected ariaName={name} color={theme.accent48} />
  ) : (
    <MapPinPointUnselected ariaName={name} color={theme.neutral35} />
  );

  return (
    <div css={styles.marker} role="button">
      {icon}
    </div>
  );
};

export const IcaPinpointMarker: React.FC<PinpointMarkerProps> = ({ name, selected }) => {
  const style = selected ? styles.markerIcaSelected : styles.markerIcaUnselected;
  return (
    <div css={[styles.markerIca, style]} role="button">
      <IcaMapPin ariaName={name} selected={selected} />
    </div>
  );
};

export const PinpointMarker: React.FC<PinpointMarkerProps> = props => {
  const category = useCategoryState();

  if (category.flags.show_carrier_logos_on_map_pin) {
    return <IcaPinpointMarker {...props} />;
  }

  return <PlainPinpointMarker {...props} />;
};

const styles = {
  marker: css({
    cursor: 'pointer',
    svg: {
      display: 'block',
    },
  }),
  markerIca: css({
    position: 'absolute',
    cursor: 'pointer',
    bottom: 0,
    marginLeft: -24,
    // exported svg got a lot of padding around the pin, I suppose its for easier taping on mobile,
    // for now offseting like that so that pin shows exact point on map
    width: '48px',
    minWidth: '48px',
  }),
  markerIcaUnselected: css({
    marginBottom: -15,
  }),
  markerIcaSelected: css({
    marginBottom: -10,
    zIndex: 1,
  }),
};
